export type SeoSettings = {
  site_name: string;
  site_url: string;
  default_title: string;
  title_suffix: string;
  default_description: string;
  default_keywords: string;
  default_og_image: string;
  twitter_handle: string;
  robots_index: boolean;
  robots_follow: boolean;
  sitemap_include_blog: boolean;
  sitemap_include_static_pages: boolean;
};

export const DEFAULT_SEO_SETTINGS: SeoSettings = {
  site_name: 'Ahime',
  site_url: '',
  default_title: 'Ahime | Studio web, mobile, SaaS et desktop',
  title_suffix: ' | Ahime',
  default_description: 'Studio produit specialise en applications web, mobiles, SaaS, desktop, Linux, APIs et cloud.',
  default_keywords: 'developpement web, application mobile, saas, application desktop, linux, flutter, react, api, cloud',
  default_og_image: '',
  twitter_handle: '',
  robots_index: true,
  robots_follow: true,
  sitemap_include_blog: true,
  sitemap_include_static_pages: true,
};

function asString(value: unknown, fallback: string): string {
  return typeof value === 'string' ? value : fallback;
}

function asBoolean(value: unknown, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

export function mergeSeoSettings(input: Partial<SeoSettings> | null | undefined): SeoSettings {
  const raw = input || {};

  return {
    site_name: asString(raw.site_name, DEFAULT_SEO_SETTINGS.site_name),
    site_url: asString(raw.site_url, DEFAULT_SEO_SETTINGS.site_url),
    default_title: asString(raw.default_title, DEFAULT_SEO_SETTINGS.default_title),
    title_suffix: asString(raw.title_suffix, DEFAULT_SEO_SETTINGS.title_suffix),
    default_description: asString(raw.default_description, DEFAULT_SEO_SETTINGS.default_description),
    default_keywords: asString(raw.default_keywords, DEFAULT_SEO_SETTINGS.default_keywords),
    default_og_image: asString(raw.default_og_image, DEFAULT_SEO_SETTINGS.default_og_image),
    twitter_handle: asString(raw.twitter_handle, DEFAULT_SEO_SETTINGS.twitter_handle),
    robots_index: asBoolean(raw.robots_index, DEFAULT_SEO_SETTINGS.robots_index),
    robots_follow: asBoolean(raw.robots_follow, DEFAULT_SEO_SETTINGS.robots_follow),
    sitemap_include_blog: asBoolean(raw.sitemap_include_blog, DEFAULT_SEO_SETTINGS.sitemap_include_blog),
    sitemap_include_static_pages: asBoolean(raw.sitemap_include_static_pages, DEFAULT_SEO_SETTINGS.sitemap_include_static_pages),
  };
}
